import React from 'react';
import './Loading.scss';
import { FlexBox } from './flex-box';

interface Props {
  isFullScreen?: boolean;
}

const Loading: React.FC<Props> = ({
  isFullScreen = true,
}) => (
  <FlexBox
    className={`loading ${isFullScreen ? 'loading--fixed' : 'loading--container'}`}
    aligns='center'
    content='center'
  >
    <FlexBox
      aligns='center'
      content='center'
      className='loading__spinner'
      aria-label='loading'
    >
      <div className='spinner-dot one'></div>
      <div className='spinner-dot two'></div>
      <div className='spinner-dot three'></div>
      <div className='spinner-dot four'></div>
      <div className='spinner-dot five'></div>
    </FlexBox>
  </FlexBox>
);

export default Loading;
